import React, { useEffect, useState } from 'react';
import { getDropdowns } from './constant';
import { ReactComponent as BackIcon } from 'assets/img/svg/BackButton.svg';
import { useHistory } from "react-router";
import TransferValidationConfig from './TransferValidationConfig';

const TransferValidationConfigPage = () => {

    const [dropdownData, setDropdownData] = useState({
        loading: false,
        data: {}
    });

    const history = useHistory();

    const getDropdown = async () => {
        setDropdownData(prev => ({ ...prev, loading: true }));
        const data = await getDropdowns();
        setDropdownData({ loading: false, data });
    }

    useEffect(() => {
        getDropdown()
    }, [])


    return (
        <div className={`remove-container-top-space d-flex flex-column p-3`}>

            <div className='mb-3'>
                <BackIcon onClick={() => history.goBack()} />
                <span className="ml-3 heading-4 color-dark">
                    Transfer validations config
                </span>
            </div>

            <TransferValidationConfig
                dropdownData={dropdownData?.data}
                dropdownDataLoading={dropdownData?.loading}
            />

            <TransferValidationConfig
                dropdownData={dropdownData?.data}
                dropdownDataLoading={dropdownData?.loading}
                isBranchLevelConfig
            />
        </div>
    )
}

export default TransferValidationConfigPage;